/*eslint sort-keys: ["error", "asc", {caseSensitive: false}]*/

export const en = {
  ban: 'Banned',
  close: 'Close',
  contact: 'Contact',
  contactDone: 'Thank you for you message.',
  contactEmail: 'Email',
  contactMessage: 'Message',
  copy: 'Copy',
  create: 'Create',
  defeat: 'DEFEAT',
  donate: 'Donate',
  draftCreate: 'Share the draft to your friends',
  draftDescription: 'Create a draft and share to your friends',
  draftList: 'List',
  draftLogs: 'Logs',
  draftSettingsCoin: 'Who start',
  draftSettingsMode: 'Guess mode',
  draftSettingsTries: 'Number of attempts',
  draftShareText: 'Hi, try to guess this draft #BSDrafting',
  fanContentPolicy: 'Fan Content Policy',
  fanContentPolicyLink: 'https://www.supercell.com/fan-content-policy',
  footer:
    "This material is unofficial and is not endorsed by Supercell.\nFor more information see Supercell's {FanContentPolicy}",
  guessLast: 'Last',
  guessTwoLast: 'Two last',
  homeDescription:
    'The site to perfect your drafting skills on Brawl Stars!\n\nCreate strategic compositions and challenge your friends to guess the picks.\nImprove your strategies with our intuitive platform and become a draft expert!',
  homeTitle: 'Welcome to BS Drafting',
  listEmptyDescription: "Let's go create your first draft",
  listEmptyTitle: 'No draft yet',
  listTeamShareText: 'Hi, try to guess this draft #BSDrafting',
  logsEmptyDescription: 'Share the site to your friends and ask them a draft',
  logsEmptyTitle: 'No log yet',
  pick: 'Pick',
  share: 'Share',
  submit: 'Submit',
  validate: 'Submit',
  victory: 'VICTORY',
};

export type ENResources = typeof en;
